<template>
  <div v-if="registration">

    <h2 class="mb-4 fw-bold">
      Registrazione
    </h2>

    <DynamicForm
  :schema="registration.fields"
  :layout="registration.layout"
  :loading="loading"
  @submitted="handleSubmit"
/>

  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm.vue' // ← QUESTA RIGA MANCAVA

export default {

  name: 'RegistrationPage',

  props: ['pages'],

  components: {
    DynamicForm // ← E QUESTA
  },

  data () {
    return {
      loading: false,
      error: null
    }
  },

  computed: {
    registration () {
      return this.pages?.registration || null
    }
  },

  methods: {

    async handleSubmit (formData) {
      if (this.loading) return

      this.loading = true

      try {
        const apiBase = process.env.VUE_APP_API
        await this.$axios.post(apiBase + '/call.php', {
          slug: this.$route.params.slug,
          payload: formData
        })

        if (this.$route.name !== 'ThankYou') {
          this.$router.push({
            name: 'ThankYou',
            params: { slug: this.$route.params.slug }
          })
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    }

  }

}
</script>
